export default {
  status: 0,
  data: [
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000092',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 1,
      DIS_ITEM_NM: '청량한 생수 500ml PET',
      DIS_ITEM_NM_KO: '청량한 생수 500ml PET',
      DIS_ITEM_NM_EN: 'Refreshing bottled water 500ml PET',
      DIS_ITEM_NM_JP: 'さわやかボトルウォーター 500mlPET',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000092',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374830',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 60,
      NAT: 45,
      CARBO: 35,
      SUGAR: 0,
      FAT: 54,
      TRANS: 12,
      CHOL: 0,
      PROTEIN: 350,
      CAFF: 0,
      ITEM_DESC: '청량한 생수',
      ITEM_DESC_KO: '청량한 생수',
      ITEM_DESC_JP: 'さわやかボトルウォーター',
      ITEM_DESC_EN: 'Refreshing bottled water',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000094',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 2,
      DIS_ITEM_NM: '비타 이온음료 500ml PET',
      DIS_ITEM_NM_KO: '비타 이온음료 500ml PET',
      DIS_ITEM_NM_EN: 'Vita ionic beverage 500ml PET',
      DIS_ITEM_NM_JP: 'ビタイオン飲料 500mlPET',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'N',
      SUB_ITEM_CD: '00000094',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374832',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 1800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '02,04,07,08',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '비타 이온음료 500ml 비타 이온음료 500ml 비타 이온음료 500ml 비타 이온음료 500ml 비타 이온음료 500ml',
      ITEM_DESC_KO: '비타 이온음료 500ml 비타 이온음료 500ml 비타 이온음료 500ml 비타 이온음료 500ml 비타 이온음료 500ml',
      ITEM_DESC_JP: 'べんとう4\nべんとう4\nべんとう4',
      ITEM_DESC_EN: 'lunch4\nlunch4\nlunch4',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000093',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 3,
      DIS_ITEM_NM: '한돈 생삼겹살 600g',
      DIS_ITEM_NM_KO: '한돈 생삼겹살 600g',
      DIS_ITEM_NM_EN: 'raw Korean pork belly 600g ',
      DIS_ITEM_NM_JP: '生韓国豚バラ肉 600g',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'N',
      SUB_ITEM_CD: '00000093',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374831',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 24500,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '02,04,08',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '한돈생삼겹살 한돈생삼겹살 한돈생삼겹살 한돈생삼겹살 한돈생삼겹살',
      ITEM_DESC_KO: '한돈생삼겹살 한돈생삼겹살 한돈생삼겹살 한돈생삼겹살 한돈생삼겹살',
      ITEM_DESC_JP: 'べんとう3\nべんとう3',
      ITEM_DESC_EN: 'lunch3\nlunch3\nlunch3\n',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000091',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 4,
      DIS_ITEM_NM: '한우 소갈비살 500g',
      DIS_ITEM_NM_KO: '한우 소갈비살 500g',
      DIS_ITEM_NM_EN: 'Korean beef ribs 500g',
      DIS_ITEM_NM_JP: '韓牛カルビ 500g',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000091',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122374829',
      //"SUB_ITEM_IMG_FILE_URL": "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122374829_1_v0001.jpg",
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 32700,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,04,09',
      CAL: 100,
      NAT: 280,
      CARBO: 220,
      SUGAR: 53,
      FAT: 58,
      TRANS: 80,
      CHOL: 15,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '한우소갈비살 한우소갈비살 한우소갈비살 한우소갈비살 한우소갈비살',
      ITEM_DESC_KO: '한우소갈비살 한우소갈비살 한우소갈비살 한우소갈비살 한우소갈비살',
      ITEM_DESC_JP: 'べんとう1',
      ITEM_DESC_EN: 'lunch1\nlunch1',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000130',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 5,
      DIS_ITEM_NM: '화이트 표백 세제 2000ml',
      DIS_ITEM_NM_KO: '화이트 표백 세제 2000ml',
      DIS_ITEM_NM_EN: 'White bleaching detergent 2000ml',
      DIS_ITEM_NM_JP: '白系漂白剤洗剤 2000ml',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000130',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376541',
      //SUB_ITEM_IMG_FILE_URL: 'https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376541_1_v0001.jpg',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 7800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,05,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '화이트표백세제 화이트표백세제 화이트표백세제 화이트표백세제 화이트표백세제',
      ITEM_DESC_KO: '화이트표백세제 화이트표백세제 화이트표백세제 화이트표백세제 화이트표백세제',
      ITEM_DESC_JP: 'べんとう5\nべんとう5\nべんとう5',
      ITEM_DESC_EN: 'lunch5\nlunch5\nlunch5',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000277',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 6,
      DIS_ITEM_NM: '화장실 슬리퍼(옐로우)',
      DIS_ITEM_NM_KO: '화장실 슬리퍼(옐로우)',
      DIS_ITEM_NM_EN: 'Bathroom slippers (yellow)',
      DIS_ITEM_NM_JP: '浴室用スリッパ（黄色）',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000277',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376540',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5600,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,04,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '게 크림 고로케 도시락\n게 크림 고로케 도시락\n게 크림 고로케 도시락',
      ITEM_DESC_KO: '게 크림 고로케 도시락\n게 크림 고로케 도시락\n게 크림 고로케 도시락',
      ITEM_DESC_JP: 'べんとう7\nべんとう7\nべんとう7',
      ITEM_DESC_EN: 'lunch7\nlunch7\nlunch7',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000278',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 7,
      DIS_ITEM_NM: '냉동 절단꽃게 500g',
      DIS_ITEM_NM_KO: '냉동 절단꽃게 500g',
      DIS_ITEM_NM_EN: 'frozen cut crab 500g',
      DIS_ITEM_NM_JP: '冷凍カットカニ 500g',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000278',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376539',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 11000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '02,03,04',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '김 도시락\n김 도시락\n김 도시락',
      ITEM_DESC_KO: '김 도시락\n김 도시락\n김 도시락',
      ITEM_DESC_JP: 'べんとう8\nべんとう8\nべんとう8',
      ITEM_DESC_EN: 'lunch8\nlunch8\nlunch8',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000276',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 8,
      DIS_ITEM_NM: '냉장 통영 싱싱한 생굴 200g',
      DIS_ITEM_NM_KO: '냉장 통영 싱싱한 생굴 200g',
      DIS_ITEM_NM_EN: 'refrigerated Tongyeong fresh raw oysters 200g',
      DIS_ITEM_NM_JP: '冷蔵統営生生牡蠣 200g',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#BEST',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000276',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376536',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 8900,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,07,09',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '',
      ITEM_DESC_KO: '',
      ITEM_DESC_JP: 'べんとう6\nべんとう6\nべんとう6',
      ITEM_DESC_EN: 'lunch6\nlunch6\nlunch6',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000279',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '생딸기 아이스크림',
      DIS_ITEM_NM_KO: '생딸기 아이스크림',
      DIS_ITEM_NM_EN: 'Fresh Strawberry Ice Cream',
      DIS_ITEM_NM_JP: 'フレッシュストロベリーアイスクリーム',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000279',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3600,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000280',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '제주도 맛있는 감귤 1.2kg',
      DIS_ITEM_NM_KO: '제주도 맛있는 감귤 1.2kg',
      DIS_ITEM_NM_EN: 'Jeju Island delicious tangerines 1.2kg',
      DIS_ITEM_NM_JP: '済州島のおいしいみかん 1.2kg',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000280',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6900,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000281',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '고당도 샤인머스켓 600g',
      DIS_ITEM_NM_KO: '고당도 샤인머스켓 600g',
      DIS_ITEM_NM_EN: 'High-sugar Shine Muscat 600g',
      DIS_ITEM_NM_JP: '高糖度シャインマスカット 600g',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000281',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 10990,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000282',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '손쉽고 구수한 시골집 된장찌개 밀키트',
      DIS_ITEM_NM_KO: '손쉽고 구수한 시골집 된장찌개 밀키트',
      DIS_ITEM_NM_EN: 'Easy and delicious country house soybean paste stew meal kit',
      DIS_ITEM_NM_JP: '簡単でおいしい田舎家の味噌シチューミールキット',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000282',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 8500,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000283',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '이천에서 온 햅쌀 20kg',
      DIS_ITEM_NM_KO: '이천에서 온 햅쌀 20kg',
      DIS_ITEM_NM_EN: '20kg of new rice from Icheon',
      DIS_ITEM_NM_JP: '利川産新米20kg',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000283',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 36000,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000284',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '테라 맥주 500ml',
      DIS_ITEM_NM_KO: '테라 맥주 500ml',
      DIS_ITEM_NM_EN: 'Terra Beer 500ml',
      DIS_ITEM_NM_JP: 'テラビール 500ml',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000284',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000285',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 10,
      DIS_ITEM_NM: '참이슬 375ml',
      DIS_ITEM_NM_KO: '참이슬 375ml',
      DIS_ITEM_NM_EN: 'Chamisul Soju 375ml',
      DIS_ITEM_NM_JP: 'チャミスル焼酎 375ml',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '#NEW',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000285',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376538',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 1800,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03,06',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_KO: '햄버그 도시락\n햄버그 도시락\n햄버그 도시락',
      ITEM_DESC_JP: 'べんとう9\nべんとう9\nべんとう9',
      ITEM_DESC_EN: 'lunch9\nlunch9\nlunch9',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'Y',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0002',
      KOS_CLASS_CD: '0001',
      DIS_ITEM_CD: '00000286',
      SHOP_ID: '0003626',
      DIS_ITEM_ORDER: 9,
      DIS_ITEM_NM: '초코 바닐라빈 아이스크림',
      DIS_ITEM_NM_KO: '초코 바닐라빈 아이스크림',
      DIS_ITEM_NM_EN: 'Chocolate vanilla bean ice cream',
      DIS_ITEM_NM_JP: 'チョコレートバニラビーンズアイスクリーム',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000286',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122376537',
      SUB_ITEM_IMG_FILE_URL: '',
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '002',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '치킨 커틀릿 도시락\n치킨 커틀릿 도시락\n치킨 커틀릿 도시락',
      ITEM_DESC_KO: '치킨 커틀릿 도시락\n치킨 커틀릿 도시락\n치킨 커틀릿 도시락',
      ITEM_DESC_JP: 'べんとう10\nべんとう10\nべんとう10',
      ITEM_DESC_EN: 'lunch10\nlunch10\nlunch10',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
  ],
  message: '',
};
